import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewCoupon = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('coupon', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addCoupon = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('coupon/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getCoupon = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('coupon/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editCoupon = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('coupon/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleCoupon = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('coupon/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
